import { render, staticRenderFns } from "./SumUpWidget.vue?vue&type=template&id=d3e18f7a"
import script from "./SumUpWidget.vue?vue&type=script&lang=js"
export * from "./SumUpWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports